import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IErrorReason, IErrorParameter, SUSPEND_FROM_ONLINE_SALES } from '@app/core/common.model';

@Injectable({
  providedIn: 'root'
})
export class HttpResponseHelperService {
  /** Extract server error codes from an HttpErrorResponse */
  getErrorCodes(error: HttpErrorResponse): string[] {
    return (
      (error.error as IErrorReason)?.params
        ?.map((param: IErrorParameter) => param.errorCode)
        .filter((code: string | undefined): code is string => code != undefined) ?? []
    );
  }

  isSuspendedFromOnlineSales(error: unknown): boolean {
    return error instanceof HttpErrorResponse && this.getErrorCodes(error).includes(SUSPEND_FROM_ONLINE_SALES);
  }
}
